import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

